module.exports = __webpack_public_path__ + "static/media/paymaya.0a63d6cb.png";